import { registerCustomElement, isAttribute } from '../utils.mjs';

export class Separator extends HTMLElement {
	get form() {
		if (!this._form) {
			this._form = this.closest('imt-forman');
		}
		return this._form;
	}

	get advanced() {
		return isAttribute(this, 'advanced');
	}

	/**
	 * Builds the separator dom.
	 *
	 * @param instructions {object} Collection of directives.
	 */

	async build(instructions) {
		this.setAttribute('title', instructions.label || '');

		if (instructions.advanced) {
			this.setAttribute('advanced', '');
			this.form._addAdvancedInput(this);

			if (!this.form.advancedParametersVisible) {
				this.classList.add('d-none');
			}
		}
	}

	disconnectedCallback() {
		if (this.hasAttribute('advanced')) {
			this.form._removeAdvancedInput(this);
		}
	}
}

// TODO: deprecated - will be removed
registerCustomElement('imt-input-separator', class extends Separator {});
registerCustomElement('imt-visual-separator', Separator);
